module.exports = __webpack_public_path__ + "static/image/history/pc/202106.ver2_0_2.jpg?60fcccae";